<template>
  <b-modal
    ref="campaign-modal"
    v-model="showModal"
    hide-header
    body-class="p-0"
    content-class="border-0"
    footer-class="justify-content-start"
  >
    <template #default>
      <campaign-content
        :campaign="campaign"
      >
      </campaign-content>
    </template>
    <template #modal-footer>
      <b-button
        variant="white"
        @click.prevent="acknowledge()"
      >
        <i class="fa fa-thumbs-up fa-fw mr-1"></i>
        OK
      </b-button>
      <a
        :href="campaign.click_url"
        target="_blank"
        class="btn btn-link"
      >
        Learn More
      </a>
    </template>
  </b-modal>
</template>

<script>
import { getCampaigns, acknowledgeCampaign } from '@/api'
import CampaignContent from './CampaignContent'

export default {
  components: {
    CampaignContent
  },
  props: {
    slotName: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      campaign: null
    }
  },
  computed: {
    showModal () {
      return !!this.campaign
    }
  },
  async mounted () {
    let response = await getCampaigns(this.slotName, null, 1)
    if (response.data.data) {
      this.campaign = response.data.data[0]
    }
  },
  methods: {
    async acknowledge () {
      let response = await acknowledgeCampaign(this.campaign.ref, this.slotName)
      this.$refs['campaign-modal'].hide()
    }
  }
}
</script>